import { render, staticRenderFns } from "./Partial-menu.vue?vue&type=template&id=452a7d95&scoped=true"
import script from "./Partial-menu.vue?vue&type=script&lang=js"
export * from "./Partial-menu.vue?vue&type=script&lang=js"
import style0 from "./Partial-menu.vue?vue&type=style&index=0&id=452a7d95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452a7d95",
  null
  
)

export default component.exports